import React from 'react';
import { View } from 'react-native';
import { useStyleSheet, useThemeContext } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
import { Icon } from '../../Icon';
import { Text } from '../../Text';
import { Button } from '../../Button';
export const Fallback = ({ style, onEdit }) => {
    const { size } = useThemeContext();
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, style] },
        React.createElement(Icon, { name: 'calendar-cancel', size: size.L }),
        React.createElement(Text, { type: 'heading', size: 'h6', style: styles.title }, "Your availability is not set"),
        React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.subTitle }, "Update your tutoring availability to get new students"),
        React.createElement(Button, { style: styles.button, type: 'primary', accent: 'default', size: 'md', onPress: onEdit, text: 'Set availability' })));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        alignItems: 'center',
        justifyContent: 'center'
    },
    title: {
        color: color.invert2.p100,
        marginTop: size.C,
        textAlign: 'center'
    },
    subTitle: {
        marginTop: size.C,
        color: color.invert2.p56,
        textAlign: 'center'
    },
    button: {
        marginTop: size.G
    }
}));
//# sourceMappingURL=Fallback.js.map